import { Table, Button, createStyles, Center, Text } from "@mantine/core";
import {
  formatDate,
  formatDateTime,
  formatObservationValue,
} from "@medplum/core";
import { Observation, ObservationComponent, Patient } from "@medplum/fhirtypes";
import { Document, useMedplum } from "@medplum/react";
import { ChartData, ChartDataset, ChartOptions } from "chart.js";
import { useEffect, useState } from "react";
import { LineChart } from "../../components/LineChart";
import { measurementsMeta } from "./Measurement.data";
import { getColorVal } from "./colormap";
import {
  AlertCircle,
  AlertTriangle,
  ChevronDown,
  ChevronUp,
} from "react-feather";
import { JsxElement } from "typescript";
import { averageObservationsByDate } from "./vitals.service";
import GenericInfoModal from "../../components/GenericInfoModal";
import fetchResourceIcon from "../../assets/img/fetchingResourceLogo.svg";
import dbStoringIcon from "../../assets/img/storingDBLogo.svg";
// import { findEpicPractitionerExtension } from "../Patient/PatientDetails/Service";
import { useSelector } from "react-redux";
import { AppState } from "../../store/types/appState";
import {
  filterByValueString,
  getAccessToken,
  pushToEpicHandler,
} from "../../utils";
import { showNotification } from "@mantine/notifications";
import { IAccumulator } from "../Appointment/AppointmentModal";
import { useDispatch } from "react-redux";
import { getPatientName } from "../Eligibility/EligibiltyService";
const useStyles = createStyles((theme) => ({
  table: {
    marginTop: "30px",
  },
  thead: {
    backgroundColor: "#BEDEF8",
    borderRadius: 4,
  },
  firstRow: {
    width: "30%",
    borderRadius: "4px 0px 0px 4px",
  },
  secondRow: {
    width: "30%",
  },
  thirdRow: {
    width: "10%",
    borderRadius: "0px 4px 4px 0px",
  },
  rowIcon: {
    marginRight: "2px",
    marginLeft: "-30px",
    marginBottom: "-5px",
  },
  rotatedImage: {
    transform: "rotate(180deg)",
  },
}));

export function Measurement(props: any): JSX.Element | null {
  const { classes } = useStyles();
  const { measurementId, patientId, deviceId, pushToEpic, setPushToEpic } =
    props;
  const medplum = useMedplum();
  const dispatch = useDispatch();

  const profile = medplum.getProfile();
  // const clientId = findEpicPractitionerExtension(profile);
  const [chartData, setChartData] = useState<ChartData<"line", number[]>>();
  const [showTable, setShowTable] = useState<boolean>(false);
  const [observations, setObservations] = useState<any>([]);
  const [obsType, setObsType] = useState<string>("");
  const [isLoading, setIsLoading] = useState(true);
  const [showInfoModal, setShowModal] = useState(false);
  const [patientName, setPatientName] = useState<any>("");
  const [succesMessage, setSuccessMessage] = useState("Storing in EPIC EHR");
  const [epicId, setEpicId] = useState<any>("");

  const [modalData, setModalData] = useState({
    title: "",
    sideTitle: "",
    details: [] as any,
    confirmText: "",
    onClose: () => {},
    onConfirm: () => {},
  });
  const modalSteps = [
    {
      loadText: "Creating Observation in EPIC EHR",

      label: "Creating Observation in EPIC EHR",

      icon: fetchResourceIcon,
    },
    {
      loadText: "Observation created successfully",
      label: "Observation created successfully",
      icon: fetchResourceIcon,
    },
    {
      loadText: succesMessage,
      label: succesMessage,
      icon: dbStoringIcon,
    },
  ];
  function transformObservationData(observation: any) {
    return {
      resourceType: "Observation",
      category: [
        {
          coding: [
            {
              system: "http://hl7.org/fhir/observation-category",
              code: "vital-signs",
              display: "Vital Signs",
            },
          ],
          text: "Vital Signs",
        },
      ],
      code: observation?.code,
      component: observation?.component,
      encounter: {
        reference: "Encounter/es09oReoYsZk20hcbnd7r4A3",
      },
      subject: {
        reference: `Patient/eAB3mDIBBcyUKviyzrxsnAw3`,
        display: "Desiree Powell",
      },
      effectiveDateTime: new Date().toISOString(),
      note: [
        {
          text: "Filed via FHIR",
        },
      ],
    };
  }
  const logginedUser = useSelector((state: AppState) => state) as any;

  const epicDataFromExtension = filterByValueString(
    logginedUser?.app?.profile?.extension || ([] as any),
    "epic"
  );

  useEffect(() => {
    const { code, chartDatasets } = measurementsMeta[measurementId as string];
    getObservationData(code, chartDatasets, deviceId);
    getPatientDetails().then((response: any) => {
      const name = getPatientName(response[0]?.name);
      setPatientName(name);

      const fhirStu3Value = response[0]?.identifier?.find(
        (identifier: any) => identifier?.type?.text === "FHIR STU3"
      )?.value;
      setEpicId(fhirStu3Value);
      // updatePayloadForEpic()
    });
  }, [measurementId, deviceId, patientId]);

  useEffect(() => {
    if (pushToEpic) {
      pushObservationsToEpic();
    }
  }, [pushToEpic]);

  const pushObservationsToEpic = () => {
    const observationPayloadForBp = transformObservationData(observations[0]);

    if (observations[0] === undefined) {
      showNotification({
        color: "red",
        message: "Data not found",
        autoClose: true,
      });
      setPushToEpic(false);
      return;
    }
    const clientId =
      epicDataFromExtension[epicDataFromExtension.length - 1]?.url?.split(
        "/"
      )?.[1];
    const observationPayload = {
      request: "createResource",
      patientId: patientId,
      clientId: clientId,
      requestParams: {
        resourceType: "Observation",
        resource: observationPayloadForBp,
      },
      oauthData: {
        accessToken:
          epicDataFromExtension[epicDataFromExtension?.length - 1]
            ?.extension?.[0]?.valueString || "",
      },
    };
    const activeLogin = getAccessToken();
    if (!clientId) {
      showNotification({
        color: "red",
        message: "Please connect EPIC client",
        autoClose: true,
      });
    }

    try {
      const result: IAccumulator = epicDataFromExtension[
        epicDataFromExtension.length - 1
      ]?.extension?.reduce((acc: IAccumulator, { url, valueString }) => {
        if (url === "refresh_token") {
          acc.refreshToken = valueString;
        } else if (url === "integrationType") {
          acc.integrationType = valueString;
        } else if (url === "display") {
          acc.name = valueString;
        }
        return acc;
      }, {});

      const metaData = {
        dispatch,
        clientId: clientId,
        integrationType: result.integrationType,
        refreshToken: result.refreshToken,
        activeLogin,
        name: result.name,
      };
      setShowModal(true);
      setModalData({
        title: " Please wait, we are creating Observation Resource in EPIC EHR",
        sideTitle: "",
        details: [
          { label: "Title", text: "" },
          { label: "Description", text: "" },
        ],
        confirmText: "Proceed",
        onClose: () => {
          setShowModal(false);
        },
        onConfirm: async () => {
          await pushToEpicHandler(medplum, observationPayload, metaData).then(
            (res) => {
              if (res?.body?.error?.includes("duplicate")) {
                showNotification({
                  color: "red",
                  message: "Record already exists in Epic",
                  autoClose: true,
                });
              }
              if (res?.status === 201) {
                showNotification({
                  color: "green",
                  message: "Record successfully pushed to Epic",
                  autoClose: true,
                });
              } else {
                setSuccessMessage("Failed ,Please try again");
                showNotification({
                  color: "red",
                  message: "Please try again",
                  autoClose: true,
                });
              }
            }
          );
        },
      });
    } catch (error) {
      console.log(error);
      showNotification({
        color: "red",
        message: `Failed ${error} `,
        autoClose: true,
      });
    } finally {
      setPushToEpic(false);
    }
  };

  const getObservationData = async (
    code: string,
    chartDatasets: any,
    deviceId: string
  ) => {
    medplum
      .searchResources(
        "Observation",
        `code=${code}&patient=${patientId}&device=Device/${deviceId}&_sort=date`
      )
      .then((res) => {
        setObservations(res);
        formatChartData(res, chartDatasets);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  const getPatientDetails = () => {
    const response = medplum.searchResources("Patient", {
      _id: patientId,
    });
    return response;
  };

  const formatObs = (obs: Observation): Array<any> => {
    if (!obs.component)
      obs.component = [{ code: obs.code, valueQuantity: obs.valueQuantity }];
    if (!obs.component[0]?.code?.text)
      obs.component[0].code.text =
        obs?.component[0]?.code?.coding?.[0]?.display;
    return (
      obs.component?.map((item: ObservationComponent) => {
        const val = item.valueQuantity?.value as number;
        let ico: any;
        const col = getColorVal(item.code?.text as any) as any;
        if (col) {
          if (val >= col.critical.max || val <= col.critical.min)
            ico = (
              <AlertCircle
                className={classes.rowIcon}
                color="rgba(255, 99, 132, 1)"
              />
            );
          // Critical Reading
          else if (val > col.high.min && val < col.high.max)
            ico = (
              <AlertTriangle
                className={classes.rowIcon}
                color="rgba(255, 205, 86, 1)"
              />
            ); // Abnormal Reading
        }
        return [ico, val + " " + item.valueQuantity?.unit];
      }) ?? ["--"]
    );
  };

  const formatChartData = (dataValues: any, chartDataSets: any) => {
    dataValues = dataValues.sort(
      (a: any, b: any) =>
        new Date(a.effectiveDateTime).getTime() -
        new Date(b.effectiveDateTime).getTime()
    );
    dataValues = averageObservationsByDate(dataValues);
    const labels: string[] = [];
    const datasets: ChartDataset<"line", number[]>[] = chartDataSets.map(
      (item: any) => ({ ...item, data: [] })
    );
    for (const obs of dataValues) {
      labels.push(
        formatDate(obs.effectiveDateTime).split("/").slice(0, 2).join("/")
      );
      if (chartDataSets.length === 1) {
        datasets[0].data.push(obs.valueQuantity?.value as number);
      } else {
        for (let i = 0; i < chartDataSets.length; i++) {
          datasets[i].data.push(
            (obs.component as ObservationComponent[])[i].valueQuantity
              ?.value as number
          );
        }
      }
    }

    // const obType = observations.find((o: any) => o.code?.text).code.text;
    const processedData = {
      labels: labels,
      datasets: datasets.map((dataset: any) => ({
        ...dataset,
        fill: false,
        pointRadius: 5,
        pointHoverRadius: 7,
        borderWidth: 1,
        pointBorderWidth: 2,
        tension: 0.3,
        borderColor: "#525252",
        pointBackgroundColor: dataset.data.map((value: any) => {
          const col = getColorVal(dataset.label) as any;
          if (col) {
            if (value >= col.critical.max || value <= col.critical.min)
              return "white"; // Critical Reading
            else if (value > col.high.min && value < col.high.max)
              return "white"; // Abnormal Reading
            else return "rgba(0, 166, 81, 1)"; // Normal Reading
          } else return dataset.borderColor;
        }),
        pointBorderColor: dataset.data.map((value: any) => {
          const col = getColorVal(dataset.label) as any;
          if (col) {
            if (value >= col.critical.max || value <= col.critical.min)
              return "rgba(255, 99, 132, 1)"; // Critical Reading
            else if (value > col.high.min && value < col.high.max)
              return "rgba(255, 205, 86, 1)"; // Abnormal Reading
            else return "rgba(0, 166, 81, 1)"; // Normal Reading
          } else return dataset.borderColor;
        }),
      })),
    };
    setChartData(processedData);
    setObsType(
      dataValues[0]?.code?.text ?? dataValues[0]?.code?.coding[0]?.display
    );
  };

  return (
    <Document>
      {chartData && <LineChart chartData={chartData} />}

      {!isLoading && (
        <Table className={classes.table}>
          <thead className={classes.thead}>
            <tr>
              <th className={classes.firstRow}>Reading Date</th>
              <th className={classes.secondRow}>
                {obsType == "Blood Pressure" ? "Systolic" : obsType}
              </th>
              {obsType == "Blood Pressure" && (
                <th className={classes.secondRow}>Diastolic</th>
              )}
              <th className={classes.thirdRow}>
                <Button onClick={() => setShowTable(!showTable)}>
                  <span className={showTable ? classes.rotatedImage : ""}>
                    <ChevronDown />
                  </span>
                </Button>
              </th>
            </tr>
          </thead>
          {showTable && observations?.length > 0 && (
            <tbody>
              {observations.map((obs: any) => (
                <tr key={obs.id}>
                  <td className={classes.firstRow}>
                    {formatDateTime(obs.effectiveDateTime as string)}
                  </td>
                  {formatObs(obs).map((item: any) => (
                    <td className={classes.secondRow}>
                      {item[0]} {item[1]}
                    </td>
                  ))}
                  <td className={classes.thirdRow}></td>
                </tr>
              ))}
            </tbody>
          )}
        </Table>
      )}
      {observations?.length === 0 && showTable && (
        <Center style={{ width: "100%", height: "200px" }}>
          <Text size="xl" color="dimmed">
            No results
          </Text>
        </Center>
      )}
      {showInfoModal && (
        <GenericInfoModal
          isOpen={showInfoModal}
          steps={modalSteps}
          modalData={modalData}
          onClose={modalData.onClose}
          onConfirm={modalData.onConfirm}
          setIsPatientModalOpen={setShowModal}
          showStepsImmediately={true}
          autoConfirm={true}
        />
      )}
    </Document>
  );
}
